export enum PaymentMethods {
  Cash = 1,
  Cheque = 2,
  DemandDrafts = 3,
  CreditCard = 4,
  DebitCard = 5,
  NetBanking = 6,
  UPI= 7,
}
